import { message } from "antd";
import { Action, action, Thunk, thunk, ThunkOn, thunkOn } from "easy-peasy";
import {
  makeAuthorizedPatchRequestToBackend,
  makeUrl
} from "../helpers/backendApi";
import { actionFunctions } from "./commonActions";
import { StoreModel } from "./model";
import { fsIdentify, safeIdentify } from "../fstory";
import { Injections } from "./store-injections";
import { thunks } from "./commonThunks";

export enum UserRole {
  SAXECAP_DEV = "saxecap_dev",
  ADMIN_READ_WRITE = "admin_read_write",
  ADMIN_READ_ONLY = "admin_read_only",
  DEFAULT = "default"
}

export interface MeData {
  id: number;
  role: UserRole;
  email: string;
  timezone: string;
}

export interface ModelMe {
  NAME: string;
  INITIAL_DATA_ENDPOINT: string;
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: boolean;
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: boolean;
  initialData: MeData | null;
  initialDataReceived: boolean;
  initialDataLoading: boolean;
  hasPrintedError: boolean;
  //
  setHasPrintedError: Action<ModelMe, void>;
  resetData: Action<ModelMe, void>;
  onLogout: ThunkOn<ModelMe, Injections, StoreModel>;
  receiveTimezone: Action<ModelMe, any>;
  receiveInitialData: Action<ModelMe, any>;
  //
  synchronizeWithFirebaseAuth: Thunk<ModelMe, any, Injections, StoreModel>;
  handleUpdateTimezone: Thunk<ModelMe, any, Injections, StoreModel>;
  maybeHandleFetchInitialData: Thunk<ModelMe, any, Injections, StoreModel>;
}

const meModel: ModelMe = {
  NAME: "me",
  INITIAL_DATA_ENDPOINT: "me",
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: false,
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: false,
  initialData: null,
  initialDataReceived: false,
  initialDataLoading: false,
  hasPrintedError: false,
  //
  // Actions
  //
  setHasPrintedError: action(s => {
    s.hasPrintedError = true;
  }),
  resetData: action(state => {
    state.initialData = null;
    state.initialDataReceived = false;
    state.initialDataLoading = false;
    state.hasPrintedError = false;

    safeIdentify(false);
  }),
  onLogout: thunkOn(
    (__, storeActions) => storeActions.firebase.logout,
    actions => {
      actions.resetData();
    }
  ),
  handleUpdateTimezone: thunk(async (actions, payload, { getState }) => {
    const url = makeUrl({ endpoint: "me" });
    const data = { timezone: payload };
    const resp = await makeAuthorizedPatchRequestToBackend({
      url,
      data,
      axiosConfig: undefined
    });
    actions.receiveTimezone(resp.data);
  }),
  receiveTimezone: action((state, payload) => {
    state.initialData.timezone = payload.timezone;
  }),
  receiveInitialData: action(actionFunctions().receiveInitialData),
  //
  // Thunks
  //
  synchronizeWithFirebaseAuth: thunk(
    async (
      actions,
      { userIsSignedIn, userMustSignIn },
      { getState, dispatch, getStoreState }
    ) => {
      // const fb_ = getFirebase();
      // const auth_ = fb_.auth();
      // const currentUser_ = auth_.currentUser;
      // const currentUser_email_ = (currentUser_ || {}).email;
      if (userMustSignIn) {
        // console.log("ribbit1", {
        //   fb_,
        //   auth_,
        //   currentUser_,
        //   currentUser_email_,
        //   other: { userIsSignedIn, userMustSignIn }
        // });
        actions.resetData();
      } else if (userIsSignedIn && !getState().initialDataReceived) {
        const {
          email,
          displayName
        } = getStoreState().firebase.firebaseState.auth;
        // console.log("ribbit2", {
        //   fb_,
        //   auth_,
        //   currentUser_,
        //   currentUser_email_,
        //   other: { userIsSignedIn, userMustSignIn, email, displayName }
        // });

        fsIdentify({ email, displayName });

        try {
          await dispatch.me.maybeHandleFetchInitialData();
        } catch (err) {
          message.error(
            "We're having some trouble signing you in. " +
              "Please try reloading the page and " +
              "email team@saxecap.com if these issues persist. Thanks!"
          );
          // @ts-ignore
          actions.setHasPrintedError(true);
          throw err;
        }
      }
    }
  ),
  maybeHandleFetchInitialData: thunks().maybeHandleFetchInitialData
};

export default meModel;
